// AUTO-GENERATED by scripts/generate-build-info.js — do not edit, do not commit.
// Lets the running app detect when a newer build has been deployed (see
// src/hooks/useAppUpdateCheck.js) while it's already open, since the mobile
// installed-web-app shell has no pull-to-refresh to fall back on.
export const BUILD_ID = '1790599706369';
